module.exports = __webpack_public_path__ + "img/RABaseBGWide.6914e32b.jpeg";